import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import businessAppLicences from './businessAppLicenses.json';
import styles from './DashboardFrontendLisenses.module.scss';

type Licence = {
    name: string;
    license: string;
    repository: string;
    author: string;
    licenseUrl: string;
};
const BusinessAppLicenses = (): ReactElement => {
    const { t: txt } = useTranslation();
    return (
        <div>
            <h1>{txt('SwLicense.BusinessAppLicenseHeader')}</h1>
            <p>{txt('SwLicense.BusinessAppLicenseDescription')}</p>
            <div className={styles.wrapper}>
                {businessAppLicences.map((license: Licence) => (
                    <div key={license.name}>
                        <div className={styles.header}>{license.name}</div>
                        <div>
                            {txt('SwLicense.LicenseType')}: {license.license}
                        </div>
                        <div>
                            {txt('SwLicense.License')}:{' '}
                            <a href={license.licenseUrl} rel="noopener noreferrer" target="_blank">
                                {license.licenseUrl}
                            </a>
                        </div>
                        <div>
                            {txt('SwLicense.Author')}: {license.author}
                        </div>
                        <div>
                            {txt('SwLicense.Repository')}:{' '}
                            <a href={license.repository} rel="noopener noreferrer" target="_blank">
                                {license.repository}
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BusinessAppLicenses;
